<app-modal
  [title]="'Convert products to package' | trans:'kiosk/convert-products-to-package-modal/header/title'"
  maxWidth="500px"
  [compact]="true"
>
  <ng-template>
    @if (data.convertProductsToPackageData) {
      <p
        [innerHTML]="'Package <b>[[packageDisplayName]] for [[packageAmount]] [[currency]]</b> available, do you want to purchase it instead?' | trans:'kiosk/convert-products-to-package-modal.Text':[['packageDisplayName', data.convertProductsToPackageData.package.displayName], ['packageAmount', (data.convertProductsToPackageData.package.amount | numberToCurrency)], ['currency', languageConfig.currency.short]]">
      </p>
    }
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="addProductToCart(data.convertProductsToPackageData.item); close();"
      >
        {{ 'Cancel' | trans:'kiosk/convert-products-to-package-modal/cancel.Button' }}
      </button>

      <button
        class="button button--md button--primary text-uppercase"
        (click)="confirmConvertToPackage()"
      >
        {{ 'Confirm' | trans:'kiosk/convert-products-to-package-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
